import React from 'react';
import Box, { BoxProps } from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';

interface P extends BoxProps {
  children: React.ReactNode;
  compressed?: boolean;
  xsUnwrap?: boolean;
  fullWidth?: boolean;
  padding?: number;
  inside?: boolean;
  afterMenu?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: Partial<P>) => ({
      padding: props.padding ? theme.spacing(props.padding) : theme.spacing(2),
      background: theme.palette.background.paper,
      marginBottom: props.compressed ? 0 : theme.spacing(2),
      width: props.fullWidth ? '100%' : 'auto',
      borderRadius: '6px',
      boxShadow: props.inside ? 'none' : '0 0 10px 1px rgba(0,0,0,0.13)',
      [theme.breakpoints.down('sm')]: {
        padding: props.padding ? theme.spacing(props.padding / 2) : theme.spacing(1),
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(props.xsUnwrap ? 0 : 1),
        background: props.xsUnwrap ? 'transparent' : theme.palette.background.paper,
        '& .MuiTableCell-root': {
          padding: theme.spacing(1, 1),
        },
      },
      paddingTop: props.afterMenu ? '96px !important' : props.padding ? theme.spacing(props.padding) : theme.spacing(2),
      marginTop: props.afterMenu ? '-80px' : undefined,
    }),
  }),
);

const Bgr = (props: P) => {
  const { children, className, compressed, xsUnwrap, fullWidth, padding, afterMenu, inside, ...restProps } = props;
  const classes = useStyles(props);
  return (
    <Box {...restProps} className={`${classes.root}${className ? ' ' + className : ''}`}>
      {children}
    </Box>
  );
};

export default Bgr;
